import styled from 'styled-components';

export const StyledTrainingDetailInfo = styled.div`
  .tdi-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 12px 36px;
    max-height: 60vh;
    min-height: 40vh;
    overflow-y: auto;
    padding-bottom: 20px;
  }

  .tdi-btns {
    padding: 28px;
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: flex-end;

    > button {
      width: auto;
    }
  }
`;

export const StyledInfoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  > div {
    width: 50%;
    margin-bottom: 0;

    > .datePickerWrapper {
      width: 270px;
      overflow: hidden;
    }

    &.left {
      width: 100%;
      > textarea {
        max-height: 280px;
      }
    }

    &.no-label {
      > span {
        color: transparent;
        user-select: none;

        > span {
          color: transparent;
          user-select: none;
        }
      }
    }
  }
`;
